import React, { useState } from "react";
import { Alert } from "@mui/material";
import PublicShell from "./components/PublicShell";
import { apiErrorMessage, portalApi } from "./publicVehicleApi";
import styles from "./publicvehicle.module.css";

const VehicleLinkRequest = () => {
  const [contact, setContact] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (contact.trim() === "") {
      setError("Please enter your phone number or email address.");
      return;
    }

    setSubmitting(true);
    setError("");
    setMessage("");
    try {
      const response = await portalApi.requestLink(contact.trim());
      setMessage(response?.data?.message || "If we found a tenant with these details, a link has been sent.");
    } catch (err) {
      console.error("[VehicleLinkRequest] Failed to request link", err);
      setError(apiErrorMessage(err, "Unable to send the link right now. Please try again."));
    } finally {
      setSubmitting(false);
    }
  };

  return (<PublicShell title="Register your vehicle" context="Get a secure link to add or update your vehicle, or invite a guest vehicle.">
    <form onSubmit={submit} className={styles.card} noValidate>
      <p className={styles.cardText}>Enter the phone number or email address on your lease and we'll send you a private link.</p>
      <div className={styles.field}>
        <label htmlFor="link-contact" className={styles.label}>Phone number or email*</label>
        <input id="link-contact" className={styles.input} value={contact} disabled={submitting} onChange={(e) => setContact(e.target.value)} autoComplete="email" />
      </div>
      {error !== "" && <Alert severity="error">{error}</Alert>}
      {message !== "" && <Alert severity="success">{message}</Alert>}
      <button type="submit" className={styles.primaryButton} disabled={submitting}>{submitting ? "SENDING..." : "SEND ME A LINK"}</button>
    </form>
  </PublicShell>);
};

export default VehicleLinkRequest;
